module.exports = __webpack_public_path__ + "img/mobile/SmartButton-skip/btn-next-portrait-up@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/SmartButton-skip/btn-next-portrait-up@3x.png
// module id = 222
// module chunks = 0